export default __webpack_public_path__ + "static/media/ic_search.35bf5e6c.svg";